import React from "react";
import { useLocation } from "react-router-dom";

// Fundido de entrada al cambiar de ruta.
//
// Hasta ahora las rutas se intercambiaban de golpe: un corte seco entre dos
// páginas. Un fundido corto con una subida mínima basta para que la navegación
// se sienta continua en lugar de a saltos.
//
// La `key` con el pathname fuerza a React a remontar el contenido, con lo que
// la animación se reproduce en cada navegación. Es deliberadamente breve
// (--dur-base) y solo de entrada: encadenar también una salida obliga a
// retener la página vieja y retrasa la nueva.
export default function PageTransition({ children }) {
  const { pathname } = useLocation();
  return (
    <div key={pathname} className="page-transition">
      {children}
    </div>
  );
}
